import { getApiActionTypes } from '../../../shared/store/storeHelpers';

export const fetchAccountsTypes = getApiActionTypes('FETCH_ACCOUNTS');
export const fetchAccountGroupsTypes = getApiActionTypes('FETCH_ACCOUNT_GROUPS');
export const fetchFunctionTypes = getApiActionTypes('FETCH_FUNCTIONS');
export const fetchScreenGroupsTypes = getApiActionTypes('FETCH_SCREEN_GROUPS');
export const fetchConsFunctionTypes = getApiActionTypes('FETCH_CONS_FUNCTIONS');
export const createAccountTypes = getApiActionTypes('CREATE_ACCOUNT');
export const updateAccountTypes = getApiActionTypes('UPDATE_ACCOUNT');
